"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SESSION_ENTRY_SEPARATOR = exports.SESSION_ENTRY_REGEXP = void 0;
exports.isValidSessionString = isValidSessionString;
exports.SESSION_ENTRY_REGEXP = /^([a-zA-Z]+)=([a-z0-9-]+)$/;
exports.SESSION_ENTRY_SEPARATOR = '&';
function isValidSessionString(sessionString) {
    return (!!sessionString &&
        (sessionString.indexOf(exports.SESSION_ENTRY_SEPARATOR) !== -1 || exports.SESSION_ENTRY_REGEXP.test(sessionString)));
}
//# sourceMappingURL=sessionStateValidation.js.map